import React, { ReactElement, ReactNode } from 'react';
import { DataCollectionValues, INITIAL_DATA_COLLECTION_VALUES } from '../../types/DataCollectionValues';
import { Formik } from 'formik';
import FormikObserver from '../../react-component/components/Persistence/FormikObserver';
import { WizardName } from '../../types';
import { loadFormDataLocalStorage } from '../../react-component/components/Persistence/formLocalStorage';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const fakeSubmitHandler = (_values: DataCollectionValues) => {
    // do nothing
};

function DataCollectionProvider({
    children,
    initialValues = {},
    wizardName,
}: {
    children: ReactNode;
    initialValues?: Partial<DataCollectionValues>;
    wizardName: WizardName;
}): ReactElement<'div'> | null {
    const ls = loadFormDataLocalStorage(wizardName);
    const crossWebData = window.wizardDefaults || {};
    return (
        <Formik
            initialValues={{ ...INITIAL_DATA_COLLECTION_VALUES, ...initialValues, ...ls, ...crossWebData }}
            validateOnChange
            onSubmit={fakeSubmitHandler}
        >
            <>
                {children}
                <FormikObserver wizardName={wizardName} />
            </>
        </Formik>
    );
}

export { DataCollectionProvider };
